<template>
  <div class="content has-text-centered"></div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      data: {},
    }
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    // console.log(decodeURI(this.$route.params.key))
    if (this.$route.params.key) {
      this.$auth.token(null, decodeURI(this.$route.params.key))
      this.$auth.data = {}
      this.$auth.loaded = true
      this.$auth.authenticated = true
      // if (window.localStorage) {
      // 	window.localStorage.setItem('default_auth_token', decodeURI(this.$route.params.key))
      // }
      // document.cookie = 'rememberMe=false'
      this.$auth.fetch().then(() => {
        // Success
        this.$router.push('/' + this.Language)
      })
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// SetAuthKey.vue?415b5bc0